import template from './operative-spendings.html';
import controller from './operative-spendings.controller';

let operativeSpendingsComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default operativeSpendingsComponent;
